<section class="faq-overview">
  <div class="row">
    <div class="col-sm-12">
      <div class="content-block faq" [ngStyle]="getStyles(slice)">
        <div class="main-expansion-panel">
          <div role="heading" tabindex="0" class="faq-title text-center"
          [innerHTML]="getHtml(slice.primary.section_title, vehicle)"></div>
          <!-- Desktop -->
          <div class="desktop">
            @for (field of slice?.fields; track field) {
              <div class="row"
                [ngStyle]="{'max-width': field.faq_group.single_column_width || '100%'}" style="margin: 0 auto;">
                @for (qAndA of field.faq_group.body[0].fields; track qAndA) {
                  <div class="col-12"
                    [ngClass]="{'col-md-4': field.faq_group.three_columns}">
                    <div class="p-2">
                      <mat-accordion multi="true" [ngStyle]="getStyles(slice)">
                        <mat-expansion-panel class="">
                          <mat-expansion-panel-header>
                            <mat-panel-title>
                              <span [innerHTML]="getHtml(qAndA.question)"></span>
                            </mat-panel-title>
                          </mat-expansion-panel-header>
                          <p class="answer" [innerHTML]="getHtml(qAndA.answer)"></p>
                        </mat-expansion-panel>
                      </mat-accordion>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
          <!-- Mobile -->
          <div class="mobile">
            @for (field of slice?.fields; track field) {
              <div class="row">
                @for (qAndA of field.faq_group.body[0].fields; track qAndA) {
                  <div class="col-12">
                    <div class="p-2">
                      <mat-accordion multi="true" [ngStyle]="getStyles(slice)">
                        <mat-expansion-panel class="">
                          <mat-expansion-panel-header>
                            <mat-panel-title>
                              <span [innerHTML]="getHtml(qAndA.question)"></span>
                            </mat-panel-title>
                          </mat-expansion-panel-header>
                          <p class="answer" [innerHTML]="getHtml(qAndA.answer)"></p>
                        </mat-expansion-panel>
                      </mat-accordion>
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</section>